import { useContext } from "react";
import _ from "lodash";

import Slider from "src/components/slider";
import Button from "src/components/button";
import Text from "src/components/text";

import { DealRoomActionEditSliderChanges, DealRoomRecipient } from "src/types/dealRoom";
import { DealRoomActionPlanContext } from "../context";

import styles from "./styles.module.scss";
const DefaultUserIcon = "/images/default_user_profile_background.png";

const getChangesSubtext = (changes: DealRoomActionEditSliderChanges) => {
  const hasRecipientChanges = Object.hasOwn(changes, "recipients");
  const hasAssetChanges = Object.hasOwn(changes, "assets");
  const hasDueDateChange = Object.hasOwn(changes, "dueDate");

  const parts: string[] = [];

  if (hasRecipientChanges) parts.push("Stakeholders");
  if (hasAssetChanges) parts.push("Attachments");
  if (hasDueDateChange) parts.push("Due Date");

  return parts.join(" + ");
};

const getRecipientIcon = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return _.get(recipient, `[${selector}].icon.thumbnail`);
};

const getRecipientName = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return `${recipient?.[selector]?.firstName} ${recipient?.[selector]?.lastName}`;
};

const getRecipientEmail = (recipient: DealRoomRecipient) => {
  const isContact = Object.hasOwn(recipient, "contact");
  const selector = isContact ? "contact" : "user";

  return `${recipient?.[selector]?.email}`;
};

const ChangeActionSlider = ({ show, handleClose, handleFinish }) => {
  const { state } = useContext(DealRoomActionPlanContext);
  const saveActionSliderData = _.get(state, "saveActionSlider");

  const action = _.get(saveActionSliderData, "action");
  const stageId = _.get(saveActionSliderData, "stageId");
  const changes = _.get(saveActionSliderData, "changes");
  const stakeholdersToBeNotified = _.get(saveActionSliderData, "stakeholdersToBeNotified");

  const loading = _.get(state, `actions[${stageId}].editAction.loading`, false);
  
  const subtext = getChangesSubtext(changes);

  const handleClick = () => {
    handleFinish(action, stageId, false);
  };

  return (
    <Slider.Dialog width="400" show={show} onClose={handleClose}>
      <Slider.Header>
        <div className={styles.headerContainer}>
          <p className={styles.header}>action item update</p>
          <p className={styles.subtext}>{subtext}</p>
        </div>
      </Slider.Header>

      <Slider.Body>
        {_.size(stakeholdersToBeNotified) > 0 && (
          <div className={styles.bodyContainer}>
            <div className={styles.stakeholdersContainer}>
              <p className={styles.headerNote}>
                These stakeholders will receive a notification about this update.
              </p>
              {
                _.map(stakeholdersToBeNotified, (recipient, index) => {
                  return (
                    <div className={styles.stakeholderContainer} key={`recipient-${index}`}>
                      <img
                        src={getRecipientIcon(recipient) || DefaultUserIcon}
                        className={styles.icon}
                      />
                      <div className={styles.stakeholderDetail}>
                        <Text
                          className={styles.stakeholderName}
                          text={getRecipientName(recipient)}
                        />
                        <p className={styles.stakeholderEmail}>{getRecipientEmail(recipient)}</p>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        )}
      </Slider.Body>

      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          text={loading ? "Confirming" : "Confirm"}
          variant="primary"
          onClick={handleClick}
          disabled={loading}
        />
        <Button text="Cancel" variant="secondary" onClick={handleClose} />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default ChangeActionSlider;
